import styled from "styled-components";
import Button from "@common/Button/Button";
import { MOBILE_MIN_WIDTH, TABLET_MAX_WIDTH } from "@constants";

export const CallToActionContainer = styled.form`
    width: 100%;
    background: var(--dark-purple);
    padding: 3rem 2.5rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    box-sizing: border-box;
    flex-direction: column;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        padding: 2.5rem 2.5rem 3rem;
    }

    @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        padding: 2rem 1.5rem;
        align-items: start;
    }

    & > p {
        display: none;
        color: #ff8f35;
        font-size: 0.75rem;
    }
`;

export const Description = styled.div`
    font-size: 1rem;
    color: var(--main-font-color);
    line-height: 1.625rem;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        margin-bottom: 1.75rem;
    }
    @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        margin-bottom: 2rem;
    }
`;

export const Title = styled.h2`
    line-height: 2.5rem;
    font-weight: 700;
    color: #fff !important;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        margin-bottom: 1rem;
    }
`;

export const Input = styled.input`
    background: transparent;
    color: #ffffff;
    font-weight: normal;
    font-size: 1.25rem;
    width: 60%;
    line-height: 1.75rem;
    padding-bottom: 0.75rem;
    border: none;
    border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.2);
    -webkit-text-fill-color: var(--main-font-color) !important;
    caret-color: white;
    outline: none;

    &::placeholder {
        color: var(--main-font-color);
        font-weight: normal;
        font-size: 1.25rem;
        line-height: 1.75rem;
    }

    &:focus-visible {
        border-bottom: 0.0625rem solid white;
    }

    &__container {
        margin-top: 2.5rem;

        &:first-child {
            margin-top: 0;
        }
    }

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        width: 100%;
        margin-bottom: 10px;
    }
`;

export const InputWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: 40px;
    justify-content: space-between;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        flex-direction: column;
    }
`;

export const ButtonContainer = styled.div`
    font-size: 1.75rem;
    line-height: 2.5rem;
    font-weight: 700;
    width: 35%;
    text-decoration: none;
    color: inherit;
    word-wrap: break-word;
    white-space: nowrap;

    @media only screen and (max-width: ${TABLET_MAX_WIDTH}px) {
        width: 100%;
    }

    @media only screen and (max-width: ${MOBILE_MIN_WIDTH}px) {
        width: 100%;
    }

    img {
        height: 1.1rem !important;
        width: 1.1rem !important;
    }
`;

export const StyledFreeGuideButton = styled(Button)``;
